<template>
  <label class="custom-label cursor-pointer flex mb-2">
    <div class="bg-white shadow min-w-5 h-5 border border-primary-lighter flex justify-center items-center mr-2">
      <input v-model="val" class="hidden" type="checkbox">
      <svg class="hidden w-4 h-4 text-secondary pointer-events-none" viewBox="0 0 172 172">
        <g
          fill="none"
          stroke-miterlimit="10"
          style="mix-blend-mode:normal"
        >
          <path d="M0 172V0h172v172z"/><path d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z" fill="currentColor" stroke-width="1"/>
        </g>
      </svg>
    </div>
    <span class="text-sm">
      <slot/>
    </span>
  </label>
</template>

<script>
export default {
  data: () => ({
    val: false,
  }),
  watch: {
    val() {
      this.$emit('input', this.val);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-label input:checked + svg {
  display: block !important;
}
</style>
